export const crewIndexEnUS = {
  crew: 'Crew',
}

export const crewIndexEsMX = {
  crew: 'Tripulación',
}
